<template>
    
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <Toast/>
                <Toolbar class="p-mb-4">
                    <template slot="left">
                        <div class="p-d-flex p-flex-column p-flex-md-row" style="margin-left: 10px;">
                            <Button type="button" label="Nomina" icon="pi pi-file-pdf" class="p-button-info"  @click="consultarReporteNominaConsumidores()" />
                        </div>
                        <div class="p-d-flex p-flex-column p-flex-md-row" style="margin-left: 10px;">
                            <Button type="button" label="Nomina Firmar" icon="pi pi-file-pdf" class="p-button-info"  @click="consultarReporteNominaConsumidoresFirmar()" />
                        </div>
                    </template>
                </Toolbar>
                <div>
                    <embed :src="pdfRuta" type="application/pdf" width="100%" height="600px" />
                </div>
            </div>
        </div>
        <DialogProgreso
            :showProgreso="showProgreso"
            :titulo="mensajeCargando">
        </DialogProgreso>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import PlanillaService from "../../service/administracion/PlanillaService";
import DialogProgreso from "../componentesglobales/DialogoProgreso.vue";
export default {
    data() {
        return {
            pdfRuta: null,
            showProgreso: null,
            mensajeCargando: null
        };
    },
    planillaService: null,
    created() {
        this.planillaService = new PlanillaService();
    },
    mounted() {
    },
    components: {
		'DialogProgreso': DialogProgreso
	},
    methods: {
        consultarReporteNominaConsumidores(){
            this.mensajeCargando = "Generando reporte";
            this.showProgreso = true;
            this.planillaService.imprimirNominaConsumidores().then(response => {
                var headers = response.headers;
                var blob = new Blob([response.data],{type:headers['content-type']});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                this.showProgreso = false;
                this.pdfRuta = link.href;
            }).catch(() => {
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Documento no existe", icon: 'warning', showConfirmButton: true, timer: 6000});
                this.showProgreso = false;
            });
        },

        consultarReporteNominaConsumidoresFirmar(){
            this.mensajeCargando = "Generando reporte";
            this.showProgreso = true;
            this.planillaService.imprimirNominaConsumidoresFirmar().then(response => {
                var headers = response.headers;
                var blob = new Blob([response.data],{type:headers['content-type']});
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                this.showProgreso = false;
                this.pdfRuta = link.href;
            }).catch(() => {
                Swal.fire({position: 'top', title: 'Advertencia!', text: "Documento no existe", icon: 'warning', showConfirmButton: true, timer: 6000});
                this.showProgreso = false;
            });
        }
    }
};
</script>